import { get, post, put, _delete } from './Tools';

const BASE = process.env.REACT_APP_SERVER;
const RESOURCE = 'supervisores';

// GET: lista de supervisores
const getAll = async () => {
  const response = await get(`${BASE}${RESOURCE}`);
  return response;
};

// POST: crear supervisor (payload = SupervisorBase)
const insert = async (payload) => {
  const response = await post(`${BASE}${RESOURCE}`, payload);
  return response;
};

// PUT: actualizar supervisor (payload debe incluir id)
const update = async (payload) => {
  const response = await put(`${BASE}${RESOURCE}`, payload);
  return response;
};

const getEmployeesBySupervisor = async (supervisorOdooId) => {
  const response = await get(`${BASE}${RESOURCE}/${supervisorOdooId}/employees`);
  return response;
};

const getEmployeesWithoutSupervisor = async () => {
  const response = await get(`${BASE}${RESOURCE}/employees/without-supervisor`);
  return response;
};

// Asignar empleado a supervisor
const assignEmployeeToSupervisor = async (supervisorOdooId, empleadoId) => {
  const response = await post(`${BASE}${RESOURCE}/${supervisorOdooId}/employees`, { empleado_id: empleadoId });
  return response;
};

// Desasignar empleado (odoo_parent_id = NULL)
const unassignEmployeeFromSupervisor = async (empleadoId) => {
  const response = await _delete(`${BASE}${RESOURCE}/employees/${empleadoId}`);
  return response;
};

export { 
    getAll, 
    insert, 
    update, 
    getEmployeesBySupervisor, 
    getEmployeesWithoutSupervisor, 
    assignEmployeeToSupervisor, 
    unassignEmployeeFromSupervisor 
};